// GeoTones – mobile "show second product image", ambient auto-cycle.
//
// HISTORY (see geotones-mobile-card-swipe.css for the same log):
//   2026-08-30: two-dot tap-toggle button.
//   2026-08-30: fixed button being stretched to cover the image.
//   2026-08-30: added swipe-on-image as an alternative to the button.
//   2026-08-31: swipe-on-image REMOVED — fought with horizontal
//     product carousels/sliders (browsing to the next product via
//     swipe also flipped the card's image).
//   2026-08-31: replaced the button with touch-hold-to-preview
//     (finger down = image 2, like desktop hover).
//   2026-08-31 (this version): touch-hold ALSO turned out to be
//     unreliable inside Dawn's native mobile slider/carousel
//     (homepage "Best sellers" section uses columns_mobile:1 +
//     swipe_on_mobile:true — a slide takes the full screen and the
//     whole gesture is claimed by the slider itself, so a touchstart
//     on the image doesn't reliably register as "reveal image 2").
//     Georg asked for whatever works best and drives the most
//     engagement/scroll, so this drops touch entirely: each card now
//     auto-crossfades between image 1 and image 2 on a timer WHILE
//     the card is visible on screen, using IntersectionObserver.
//     This has three advantages: (1) it can never conflict with any
//     slider/carousel/scroll gesture, because it doesn't listen to
//     touch at all; (2) it works identically in the plain 2-column
//     grid and inside the 1-column swipe carousel; (3) motion in a
//     scroll feed is a proven attention/engagement pattern (similar
//     to how Instagram/TikTok shop cards animate) — it should help
//     both "show the second photo" and "keep people scrolling".
//     Desktop (>=990px) is completely untouched — this never runs
//     there, hover keeps working exactly as Dawn ships it.
(function () {
  var CYCLE_MS = 1900; // time each image is shown before crossfading
  var MAX_STAGGER_MS = 700; // random start offset so cards don't blink in sync
  var timers = new WeakMap();

  function isMobile() {
    return window.matchMedia('(max-width: 989px)').matches;
  }

  function hasSecondImage(card) {
    var media = card.querySelector('.media--hover-effect');
    return !!(media && media.querySelectorAll('img').length > 1);
  }

  function start(card) {
    if (timers.has(card)) return;
    function loop() {
      card.classList.toggle('card--show-second');
      timers.set(card, setTimeout(loop, CYCLE_MS));
    }
    timers.set(card, setTimeout(loop, Math.random() * MAX_STAGGER_MS));
  }

  function stop(card) {
    var id = timers.get(card);
    if (id) clearTimeout(id);
    timers.delete(card);
    card.classList.remove('card--show-second');
  }

  function init() {
    if (!isMobile() || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var card = entry.target;
          if (!hasSecondImage(card)) return;
          if (entry.isIntersecting) {
            start(card);
          } else {
            stop(card);
          }
        });
      },
      { threshold: 0.6 }
    );

    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      observer.observe(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
